export const PersianMonthDays = [
  31,
  31,
  31,
  31,
  31,
  31,
  30,
  30,
  30,
  30,
  30,
  29,
];
export const PersianMonthNames = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

export const weekDays = [
  { englishName: "saturday", persianName: "شنبه" },
  { englishName: "sunday", persianName: "یک‌شنبه" },
  { englishName: "monday", persianName: "دوشنبه" },
  { englishName: "tuesday", persianName: "سه‌شنبه" },
  { englishName: "wendsday", persianName: "چهارشنبه" },
  { englishName: "thursday", persianName: "پنج‌شنبه" },
  { englishName: "friday", persianName: "جمعه" },
];

export const dayIndex = {
  saturday: 1,
  sunday: 2,
  monday: 3,
  tuesday: 4,
  wendsday: 5,
  thursday: 6,
  friday: 7,
};
export const twoDigitFormat = (hour, min) => {
  return ("0" + hour).slice(-2) + ":" + ("0" + min).slice(-2);
};

export const clockFormat = (num) => {
  const hour = Math.floor(num / 60);
  const min = Math.floor(num % 60);

  return twoDigitFormat(hour, min);
};

export function convertClockToMinute(clock) {
  const hour = clock.split(":")[0];
  const minute = clock.split(":")[1];

  if (hour && minute) {
    return Math.floor(Number(hour)) * 60 + Math.floor(Number(minute));
  }

  return 0;
}
